import { Stack, Typography, useTheme } from "@mui/material";
import { useActionsContext } from "src/context/Actions/useActionsContext";
import { useTranslation } from "react-i18next";
import { isAppInPDFMode } from "src/utils/rendering";
import { useResponsiveBreakpoints } from "src/utils/useResponsiveBreakpoints";
import { GridTableActions } from "src/components/Grid/headers/GridTableActions";
import { useColumnsTableAction } from "src/components/Grid/headers/useColumnsTableAction";
import { useActionsListContext } from "../ActionsListContext";

type ListPlanningHeaderProps = {
    isEdit: boolean;
    toggleEdit: () => void;
};
export const ListPlanningHeader = (props: ListPlanningHeaderProps) => {
    const theme = useTheme();
    const { actionPlanStats } = useActionsContext();
    const isPdfMode = isAppInPDFMode();
    const { isMobile } = useResponsiveBreakpoints();
    const { mrt_columns } = useActionsListContext();
    const columnsAction = useColumnsTableAction(mrt_columns);

    return (
        <Stack
            flexDirection={"row"}
            gap={theme.spacing(4)}
            sx={{
                justifyContent: "space-between",
                alignItems: "center",
            }}
        >
            {actionPlanStats.engagedActions <= 0 ?
                <NoItemsHeader />
            :   <HeaderLine />}

            {!isPdfMode && !isMobile && <GridTableActions actions={[columnsAction]} appearance="legacy" />}
        </Stack>
    );
};

const HeaderLine = () => {
    const theme = useTheme();
    const { actionPlanStats } = useActionsContext();
    const { t } = useTranslation();

    return (
        <Stack gap={theme.spacing(1)} flexDirection="row" alignItems={"center"} justifyContent={"center"}>
            <Typography variant={"h3"}>{t("actions.engaged_actions", "Engaged actions")}</Typography>
            <Typography variant={"huge"}>{"-"}</Typography>
            <Typography variant={"huge"}>{actionPlanStats.engagedActions}</Typography>
            {/* <Button
                variant="ternary"
                startIcon={<FoodsIcon size={2} icon={"filter"} />}
            >
                <Typography variant={"body-medium"}>
                    {"Filtrer"}
                </Typography>
            </Button> */}
        </Stack>
    );
};

const NoItemsHeader = () => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Stack gap={theme.spacing(1)} flexDirection="row" alignItems={"center"} justifyContent={"center"}>
            <Typography variant={"h3"}>{t("actions.engaged_actions", "Engaged actions")}</Typography>
            <Typography variant={"huge"}>{"-"}</Typography>
            <Typography variant={"huge"}>0</Typography>
        </Stack>
    );
};
